import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import {
  connectedUsersSearchDefaults,
  connectedUsersSearchSchema,
  pickFilters,
} from "@/app/oauth/accounts/search";
import { AccountsTable } from "@/app/oauth/accounts/table";
import { connectedAccountsQueryOptions } from "@/app/oauth/api/get-connected-accounts";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users"
)({
  validateSearch: connectedUsersSearchSchema,
  search: {
    middlewares: [stripSearchParams(connectedUsersSearchDefaults)],
  },
  component: AccountsTable,
  loaderDeps: ({ search }) => ({
    filters: pickFilters(search),
    limit: search.limit,
    offset: search.offset,
  }),
  beforeLoad: (ctx) =>
    requireProjectPermission(ctx, PROJECT.userConnections.read),
  loader: ({ context: { queryClient }, params, deps }) => {
    queryClient.prefetchQuery(
      connectedAccountsQueryOptions({
        scope: params,
        filters: deps.filters,
        limit: deps.limit,
        offset: deps.offset,
      })
    );
    return { crumb: "Connected Users" };
  },
});
